import { DocumentApi } from 'Api/Document/DocumentApi';
import { Button } from 'Components/Buttons/Buttons';
import { useCachedData } from 'Components/Context/CachedDataContext';
import { Modal } from 'Components/Modal/Modal';
import { ICON_CLOSE } from 'Config/Icons';
import { iso8601ToUsDateShort } from 'Helpers/DateTimeUtils/DateTimeUtils';
import { UserNameFormat, getUserNameFromSubject } from 'Helpers/UserUtils';
import { ActionHistory } from 'Models/Actions';

import { ActionDetailsSnapshot } from './ActionDetailsSnapshot';

export interface ActionHistoryModalProps {
    history: ActionHistory;
    documentApi: DocumentApi;
    hideModal: () => void;
}

/**
 * Renders a modal that displays a detailed historical snapshot of an action. Matches the "main" section (containing current information) of the Action Details page. Does not include information about associated risks.
 */
export const ActionHistoryModal = (props: ActionHistoryModalProps) => {
    const cachedData = useCachedData();

    return (
        <Modal open header={props.history.title} subHeader={`Last updated: ${iso8601ToUsDateShort(props.history.last_updated)} by ${getUserNameFromSubject(props.history.last_updated_by, cachedData.users, UserNameFormat.FIRST_SPACE_LAST)}`}>
            <ActionDetailsSnapshot type="historical" action={props.history} documentApi={props.documentApi} />
            <div className={'modalFormButtonContainer'}>
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
